import dayjs from 'dayjs';
import isLeapYear from 'dayjs/plugin/isLeapYear';
import isToday from 'dayjs/plugin/isToday';
import localeData from 'dayjs/plugin/localeData';
import relativeTime from 'dayjs/plugin/relativeTime';
import utc from 'dayjs/plugin/utc';
import weekday from 'dayjs/plugin/weekday';

const FALLBACK_LANGUAGE = 'en';

export const initLanguagesForThirdPartyLibs = () => {
  const INIT_LOCALE = FALLBACK_LANGUAGE;

  import(/* @vite-ignore */ `dayjs/locale/${INIT_LOCALE}.js`)
    .then(() => {
      dayjs.locale(INIT_LOCALE);
    })
    .catch(() => {
      import(/* @vite-ignore */ `dayjs/locale/${FALLBACK_LANGUAGE}.js`).then(() => {
        dayjs.locale(FALLBACK_LANGUAGE);
      });
    });
};

export const initDayJsPlugins = () => {
  dayjs.extend(isLeapYear);
  dayjs.extend(weekday);
  dayjs.extend(localeData);
  dayjs.extend(utc);
  dayjs.extend(isToday);
  dayjs.extend(relativeTime);
};
